module.exports = __webpack_public_path__ + "index/img/notice_icon.4121090e.png";